import { Button, Form, Layout, message, Modal, Typography } from "antd";
import { FunctionComponent, useEffect, useState } from "react";
import PageHeader from "../../../../components/page-header/PageHeader";
import { routesConfig } from "../../../../config/routes";
import SafeLink from "../../../../components/link/SafeLink";
import { useLocation } from "react-router-dom";
import CustomCard from "../../../../components/custom-card/CustomCard";
import "./shared-categories-management-detail.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { exportExcelMoocPortfolioDetail } from "../../../../service/category-management/shared-categories-management";
import { formatDateV2 } from "../../../../utils/converDate";
import { useTranslation } from "react-i18next";

const { Content } = Layout;
const imgPath = "/images/";

const SharedCategoriesManagementDetail: FunctionComponent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [parentCate, setParentCate] = useState<string>("");
  const [isShowSubmitButton, setIsShowSubmitButton] = useState(true);
  const [isRendering, setIsRendering] = useState(false);

  const listBreadcrumb = [
    {
      title: t("Quản lý danh mục", "Quản lý danh mục"),
    },
    {
      title: (
        <SafeLink
          to={`/${routesConfig.categoryManagement}/${routesConfig.sharedCategoriesManagement}`}
        >
          <span>{t("Quản lý danh mục dùng chung", "Quản lý danh mục dùng chung")}</span>
        </SafeLink>
      ),
    },
    {
      title: location.state?.name,
    },
  ];

  useEffect(() => {
    if (location.state?.record?.parentId && location.state?.dataPortfolio) {
      location.state.dataPortfolio.forEach((item: any) => {
        if (item.id === location.state.record.parentId) {
          setParentCate(item.name);
        }
      });
    }
  }, [location.state]);

  const handleExportExcel = () => {
    Modal.confirm({
      title: t("Xác nhận kết xuất danh sách danh mục dùng chung", "Xác nhận kết xuất danh sách danh mục dùng chung"),
      content: ``,
      onOk: () => exportExcel(),
      centered: true,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
      footer: (_, { OkBtn, CancelBtn }) => (
        <>
          <CancelBtn />
          <OkBtn />
        </>
      ),
    });
  };

  const exportExcel = async () => {
    setIsRendering(true);

    try {
      const res = await exportExcelMoocPortfolioDetail(location.state?.record?.id);

      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = `${location.state?.name}_Thong_tin_chi_tiet.xlsx`;
      downloadLink.click();

      message.success(t("Tải xuống thành công!", "Tải xuống thành công!"));
    } catch (error) {
      console.error("Download error:", error);
      message.error(t("Có lỗi xảy ra vui lòng thử lại!", "Có lỗi xảy ra vui lòng thử lại!"));
    } finally {
      setIsRendering(false);
    }
  };

  return (
    <>
      <Content>
        <PageHeader
          title={location.state?.name ? location.state?.name : ""}
          listBreadcrumb={listBreadcrumb}
          arrowLeft={imgPath + "arrowLeft.svg"}
          positionItem="column"
          breadcrumb={true}
          headerGroupButton={isShowSubmitButton}
          childrenGroupButton={
            <Button type="primary" onClick={handleExportExcel}>
              <Typography.Text>
                {isRendering ? <LoadingOutlined /> : ''} {t("Kết xuất thông tin chi tiết", "Kết xuất thông tin chi tiết")}
              </Typography.Text>
            </Button>
          }
        />
        <section className="wrapper-settings category-management-detail">
          <div className="setting-category wrapper-inside">
            <CustomCard className="header-card" title={t("Thông tin danh mục dùng chung", "Thông tin danh mục dùng chung")}>
              <Form.Item className="setting-item" name="cateName" label={t("Tên danh mục", "Tên danh mục")}>
                <p className="category-content">{location.state?.name}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="cateCode" label={t("Mã danh mục", "Mã danh mục")}>
                <p className="category-content">
                  {location.state?.record?.code}
                </p>
              </Form.Item>
              <Form.Item className="setting-item" name="cateDad" label={t("Danh mục cha", "Danh mục cha")}>
                <p className="category-content">{parentCate}</p>
              </Form.Item>
              <Form.Item className="setting-item" name="status" label={t("Trạng thái", "Trạng thái")}>
                <p>
                  {location.state?.record?.status ? (
                    t("Hoạt động", "Hoạt động")
                  ) : (
                    t("Không hoạt động", "Không hoạt động")
                  )}
                </p>
              </Form.Item>
              <Form.Item className="setting-item" name="createdDate" label={t("Ngày tạo", "Ngày tạo")}>
                <p className="created-date"> {formatDateV2(location.state?.record?.createdDate)} </p>
              </Form.Item>
            </CustomCard>
          </div>
        </section>
      </Content>
    </>
  );
};

export default SharedCategoriesManagementDetail;
